const UserRegistration = ({ user }) => {
  const users = user?.recent_registration?.users || [];

  return (
    <div className="upcoming-book h-100">
      <div className="d-flex justify-content-between align-items-center upcoming-head pad-head">
        <h6>Recently Registered Users</h6>
      </div>

      <div className="d-flex justify-content-between align-items-center employeesec">
        <div className="carousel-sec">
          {users.length > 0 ? (
            users.slice(0, 6).map((user) => {
              const registeredDate = user?.created_on?.split(" ")[0] || "--";
              const sourceLabel =
                user?.registration_source_label || user?.registration_source || "Unknown";

              return (
                <div className="dashboardimg" key={user?.id}>
                  <h6>
                    <span className="dashboard-recent-main">
                      {user?.company_name || user?.full_name || `Customer #${user?.id}`}
                    </span>
                    <span className="dashboard-recent-meta">
                      {registeredDate} / {sourceLabel}
                    </span>
                  </h6>
                </div>
              );
            })
          ) : (
            <div className="dashboard-empty-state">No records found</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserRegistration;
